import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white dark:bg-[#050816] border-t border-black/5 dark:border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">

        {/* Top Section */}
        <div className="grid gap-12 md:grid-cols-4">

          {/* Brand */}
          <div>
            <h3
              className="text-2xl font-extrabold mb-4
              bg-gradient-to-r from-blue-600 via-cyan-500 to-indigo-600
              bg-clip-text text-transparent"
            >
              360Support
            </h3>
            <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
              A digital solutions company helping businesses design, develop,
              and scale reliable products with full-cycle support.
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-3 text-sm text-slate-600 dark:text-slate-400">
              <li>
                <Link to="/about" className="hover:text-blue-600 transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-blue-600 transition">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-blue-600 transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-3 text-sm text-slate-600 dark:text-slate-400">
              <li>Branding & Creativity</li>
              <li>Web Development</li>
              <li>Search Engine Optimization</li>
              <li>Social Media Marketing</li>
              <li>Performance Marketing</li>
              <li>Video & Media Production</li>
            </ul>
          </div>

          {/* Contact */}
          {/* Contact */}
<div>
  <h4 className="font-semibold mb-4">Contact</h4>
  <ul className="space-y-3 text-sm text-slate-600 dark:text-slate-400">
    
    {/* Main Email */}
    <li>
      <span className="font-medium">Email:</span>{" "}
      <a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=360supp0rt.agency@gmail.com"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-blue-600 transition"
>
  360supp0rt.agency@gmail.com
</a>
    </li>

    {/* Careers Email */}
    <li>
      <span className="font-medium">Careers:</span>{" "}
      <a
        href="mailto:hr@360support.com"
        className="hover:text-blue-600 transition"
      >
        hr@360support.com
      </a>
    </li>

    {/* Phone Number */}
    <li>
      <span className="font-medium">Phone no:</span>{" "}
      <a
        href="tel:8658946360"
        className="hover:text-blue-600 transition"
      >
        8658946360
      </a>
    </li>

  </ul>
</div>
        </div>

        {/* Bottom Section */}
        <div className="mt-14 pt-8 border-t border-black/5 dark:border-white/10
          flex flex-col md:flex-row justify-between items-center gap-4">
          
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} 360Support. All rights reserved.
          </p>

          <p className="text-sm text-slate-500">
            Designed & built with care by 360Support
          </p>
        </div>
      </div>
    </footer>
  );
}
